import moment from "moment";

/**
 * Format a Date to YYYY-MM-DD using LOCAL time (not UTC).
 * Replaces date.toISOString().split("T")[0] which shifts dates
 * in positive UTC offsets.
 */
export const formatDateLocal = (date: Date): string => {
  return moment(date).format("YYYY-MM-DD");
};
